import type { PropsWithChildren, ReactNode } from "react";

import type { IManagementCardChipProps } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardChip";
import ManagementCardChip from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardChip";
import type { IManagementCardHeaderProps } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardHeader";
import ManagementCardHeader from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCardHeader";

import {
    StyledManagementCardBodySlot,
    StyledManagementCardFooterSlot,
    StyledManagementCardGridWrapper,
    StyledManagementCardHeaderSlot,
} from "./styles";

export interface IManagementCardProps extends IManagementCardHeaderProps, IManagementCardChipProps {
    dataAutomation?: string;
    headerBadge?: ReactNode;
    isStatusInProgress?: boolean;
    chipText?: string;
    footer?: ReactNode;
}

const ManagementCard = ({
    dataAutomation,
    chipText,
    chipType = "success",
    headerBadge,
    isStatusInProgress,
    tooltipText,
    footer,
    children,
    ...headerProps
}: PropsWithChildren<IManagementCardProps>) => {
    return (
        <StyledManagementCardGridWrapper data-automation={dataAutomation}>
            <StyledManagementCardHeaderSlot>
                <ManagementCardHeader {...headerProps}>
                    {headerBadge}
                    {chipText ? (
                        <ManagementCardChip
                            isLoading={isStatusInProgress}
                            chipType={chipType}
                            tooltipText={tooltipText}
                        >
                            {chipText}
                        </ManagementCardChip>
                    ) : null}
                </ManagementCardHeader>
            </StyledManagementCardHeaderSlot>

            {children ? <StyledManagementCardBodySlot>{children}</StyledManagementCardBodySlot> : null}

            {footer ? <StyledManagementCardFooterSlot>{footer}</StyledManagementCardFooterSlot> : null}
        </StyledManagementCardGridWrapper>
    );
};

export default ManagementCard;
